import AtomSkeleton from '@s-ui/react-atom-skeleton'

import {useSkeletonGroups} from '../hooks/useSkeletonGroups.js'

const BASE_CLASS = 'mt-NetDrawer-chat'

const NetChatRestoringSkeleton = () => {
  const {containerRef, groups} = useSkeletonGroups()

  return (
    <div ref={containerRef} className={`${BASE_CLASS}-restoring`} aria-hidden="true">
      {groups.map(({role, widths}, groupIndex) => (
        <div key={`${role}-${groupIndex}`} className={`${BASE_CLASS}-restoring--${role}`}>
          {widths.map((width, rowIndex) => (
            <AtomSkeleton key={`${role}-${groupIndex}-${rowIndex}`} height={24} width={width} />
          ))}
        </div>
      ))}
    </div>
  )
}

NetChatRestoringSkeleton.displayName = 'NetChatRestoringSkeleton'

export default NetChatRestoringSkeleton
